// Tabs/Accordions Sections
import { getAges, getBookInteriorImages } from '../utils/get-book-info'
import { otherCoversModal } from '../utils/other-covers-modal'

function hideEbookBuyButton () {
  if (window.theme.settings.template !== 'product.supadu') return
  if (
    !window.theme.productData ||
    !window.theme.productData.variants ||
    !window.theme.productData.variants.length
  ) {
    return
  }
  const variant = window.theme.productData.variants.find(
    (variant) => variant.title === 'Default Title'
  )
  if (!variant || variant.requires_shipping) return
  // hide buy button for all products that don't require shipping (i.e. not physical products)
  const buyButtonContainer = document.querySelector(
    '.js-product-form__switch-format'
  )
  buyButtonContainer.style.display = 'none'
}

async function addStockMessaging () {
  if (window.theme.settings.template !== 'product.supadu') return
  // If no product price due to data issues, no need to show any stock message
  if (!window.theme.productData.price) return
  try {
    if (
      !window.theme.productData ||
      !window.theme.productData.variants ||
      !window.theme.productData.variants.length
    ) {
      return
    }
    const buyButtonContainer = document.querySelector(
      '.js-product-form__switch-format'
    )
    if (!buyButtonContainer) return
    const variant = window.theme.productData.variants.find(
      (variant) => variant.title === 'Default Title'
    )
    if (!variant || !variant.barcode) return
    const requestUrl = `https://add-to-cart.supadu.com/add-to-cart?action=availability&isbn=${variant.barcode}&client=tokyo-pop`
    const response = await fetch(requestUrl)
    const responseJSON = await response.json()
    if (responseJSON.msg) {
      const stockMessage = `
        <div class="tokyopop-stock-message">
          <span>
            <strong>${responseJSON.msg}</strong>
          </span>
        </div>
      `
      buyButtonContainer.insertAdjacentHTML('afterend', stockMessage)
    }
    if (!responseJSON.show) {
      buyButtonContainer.style.display = 'none'
    }
  } catch (e) {
    // console.log(e)
  }
}

function showAge () {
  if (window.theme.settings.template !== 'product.supadu') return
  const item = window.theme.staticProductData
  if (!item) return
  let ages = getAges(item)
  if (!ages) return
  const productVendor = document.querySelector('.product-vendor')
  const agesSplit = ages.split('-')
  if (agesSplit[1] && agesSplit[1] === '99') {
    ages = `${agesSplit[0]}⁺`
  }
  productVendor.insertAdjacentHTML('afterend', `<p class="product__level">Age: ${ages}</p>`)
}

function enlargeCoverLink () {
  if (window.theme.settings.template !== 'product.supadu') return
  const coverElement = document.getElementById('products-details-image').querySelector('img')
  let coverSrc = coverElement.getAttribute('src')
  coverSrc = coverSrc.replace('w=300', 'w=1000').replace('w=400', 'w=1000')
  const anchorLink = document.createElement('a')
  anchorLink.setAttribute('href', coverSrc)
  anchorLink.setAttribute('title', coverElement.getAttribute('alt'))
  anchorLink.setAttribute('target', '_blank')
  anchorLink.appendChild(coverElement.cloneNode(true))
  coverElement.parentNode.replaceChild(anchorLink, coverElement)
}

function addBackcoverToInteriorImages () {
  if (window.theme.settings.template !== 'product.supadu') return
  const item = window.theme.staticProductData

  if (!item.assets || !item.assets.length) {
    return
  }

  const backcovers = item.assets.filter(asset => {
    return asset.asset.sub_type === 'back-cover'
  })

  if (!backcovers.length) return
  const backcover = backcovers.at(-1)

  // format backcover image to match other interior images
  let backcoverImageUrl = new URL(backcover.asset.path)
  backcoverImageUrl.searchParams.delete('h')
  backcoverImageUrl.searchParams.set('w', '145')
  backcoverImageUrl = backcoverImageUrl.toString()

  const otherCoversContainer = document.getElementById(
    'product-details-other-covers'
  )

  // clear existing slick slider before adding again
  otherCoversContainer.innerHTML = ''
  otherCoversContainer.classList.remove('slick-initialized')
  otherCoversContainer.classList.remove('slick-slider')

  getBookInteriorImages(item)
  otherCoversContainer.insertAdjacentHTML(
    'afterbegin',
    `<img src="${backcoverImageUrl}" alt="${item.title}" class="js-modal-open-product-image-modal">`
  )

  const otherCovers = document.querySelectorAll('#product-details-other-covers img')
  if (otherCovers.length > 3) {
    // eslint-disable-next-line no-undef
    $('#product-details-other-covers').slick({
      infinite: true,
      slidesToShow: 3,
      slidesToScroll: 3
    })
    // eslint-disable-next-line no-undef
    $('#product-details-other-covers').slick('refresh')
  }
  otherCoversModal(otherCovers)
}

function customFunctions () {
  hideEbookBuyButton()
  addStockMessaging()
  showAge()
  enlargeCoverLink()
  addBackcoverToInteriorImages()
}

module.exports = { customFunctions }
